var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"30px","text-align":"center"}},[_c('v-icon',{staticStyle:{"color":"#a0a0a0","opacity":"1"},attrs:{"name":"hourglass-half","scale":"2"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"15px","color":"#a0a0a0","font-size":"1.3em"}},[_vm._v("Les résultats sont en attente de publication. Revenez plus tard...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }